<template>
  <div class="card-authentication">
    <div class="title">学生身份认证</div>
    <div class="sfz">
      身份证号：
      <input type="text" v-model="sfzValue" @input="sfzChange" placeholder="请输入身份证号" />
    </div>
    <div class="xsz">
      学生证号：
      <input type="text" v-model="xszValue" @input="xszChange" placeholder="请输入学生证号" />
    </div>
    <div class="agree_rule">
      <img @click="agree" v-if="!agreeData" src="../../../../images/icon/auth_radio.png" alt="" />
      <img @click="agree" v-if="agreeData" src="../../../../images/icon/auth_radio_checked.png" alt="" />
      <div class="link">
        阅读并同意
        <div class="name" @click="goWebview">《友邻少年用户许可协议和隐私政策议》</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'cardAuthentication',
  data() {
    return {
      sfzValue: '',
      xszValue: '',
      agreeData: true
    }
  },
  computed: {
    ...mapGetters('payment/address', ['address']),
    isEmpty() {
      return !(this.address.id && this.address.contactName)
    },
    addressArea() {
      const [p, c, a] = this.isEmpty ? [] : this.address.addressArea.split(' / ')
      return { p, c, a }
    }
  },
  methods: {
    sfzChange() {
      this.$emit('sfzChange', this.sfzValue)
    },
    xszChange() {
      this.$emit('xszChange', this.xszValue)
    },
    agree() {
      this.agreeData = !this.agreeData
      this.$emit('agree', this.agreeData)
    },
    goWebview() {
      //location.href = '/static/userAgreement.html'
      this.$router.push({ name: 'yhxy' })
    }
  }
}
</script>

<style lang="scss" scoped>
.card-authentication {
  .title {
    font-size: 0.32rem;
    margin: 0.48rem 0 0 0.48rem;
    font-weight: bold;
  }
  .sfz,
  .xsz {
    line-height: 1.36rem;
    color: #666666;
    margin-left: 0.48rem;
    margin-right: 0.48rem;
    font-size: 0.28rem;
  }
  input {
    outline: none;
    border: none;
    font-size: 0.28rem;
    user-select: auto;
  }
  .sfz {
    border-bottom: 0.01rem solid #eeeeee;
  }
}
.agree_rule {
  display: flex;
  display: flex;
  justify-content: left;
  height: 0.5rem;
}

.agree_rule img {
  width: 0.32rem;
  height: 0.32rem;
  margin: 0;
  margin-right: 0.16rem;
  margin-left: 0.48rem;
}
.agree_rule .link {
  font-size: 0.24rem;
  display: flex;
}
.agree_rule .name {
  color: #00b25a;
}
</style>
